var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgW5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 59,
    fill: "#FFF536"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 80C41.3833 80 40.2847 79.5431 39.3708 78.6292C38.4569 77.7153 38 76.6167 38 75.3333V42.6667C38 41.3833 38.4569 40.2847 39.3708 39.3708C40.2847 38.4569 41.3833 38 42.6667 38H56.6667V80H42.6667ZM61.3333 80V59H80V75.3333C80 76.6167 79.5431 77.7153 78.6292 78.6292C77.7153 79.5431 76.6167 80 75.3333 80H61.3333ZM61.3333 54.3333V38H75.3333C76.6167 38 77.7153 38.4569 78.6292 39.3708C79.5431 40.2847 80 41.3833 80 42.6667V54.3333H61.3333Z",
    fill: "#16A02C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW5);
export default __webpack_public_path__ + "static/media/w5.39989a15e7e8f917f9d2045dfef90c22.svg";
export { ForwardRef as ReactComponent };